import { getDeviceId } from '@/utils/getDeviceId';
import api from '../axios/axiosInstance';

export interface posForm {
  name: string;
  deviceId?: string;
  deviceType?: string;
  storeId?: string;
}

export interface posResponse {
  ID: string;
  name: string;
  deviceId: string;
  number: number;
  deviceType: string;
  storeId?: string;
}

const posCreate = async (data: posForm): Promise<posResponse> => {
  const deviceId = await getDeviceId();
  const response = await api.post('/pos', { ...data, deviceId, deviceType: 'web' });
  return response.data;
};

export default posCreate;
